import React, { useEffect, useState } from "react";
import "./Federal.css";
import api from "../../../../../services/baseUrl";
import { useParams } from "react-router-dom";
import SpecialSearch from "../../../SpecialSearch";
import Modal from "../../../search/Modal";
import Pagination from "../../../../../components/Pagination";
import download from "downloadjs";
import { CircularProgress } from "@mui/material";

const MedalFederalPage = () => {
  const [data, setData] = useState([]);
  const { stateId } = useParams();
  const [pageCount, setPageCount] = useState(0);
  const [currentItems, setCurrentItems] = useState([]);
  const [itemOffset, setItemOffset] = useState(0);
  // const [sortConfig, setSortConfig] = useState({ key: "", direction: "asc" });
  const [currentPage, setCurrentPage] = useState(0);
  const [limit, setLimit] = useState(10);
  const [totalResults, settotalResults] = useState(0);
  const [query, setQuery] = useState("");

  const [fileUUID, setFileUUID] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [file, setFile] = useState(null);
  const [titleId, setTitleId] = useState(0);
  const [stateName, setStateName] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const response = await api.post(
          "api/egazette-documents/egazette/special",
          {
            stateId,
            categoryId: 3,
          }
        );
        setData(response.data);

        const stateResponse = await api.get(
          `api/egazette-documents/librariesByState/${stateId}`
        );

        setStateName(stateResponse.data.name);
      } catch (error) {
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [stateId]);

  useEffect(() => {
    const endOffset = itemOffset + limit;
    const slicedData = data.slice(itemOffset, endOffset);

    const sortedData = slicedData.sort((a, b) => {
      const dateA = new Date(a.egDocumentDto.publicationDate);
      const dateB = new Date(b.egDocumentDto.publicationDate);
      return dateB - dateA;
    });

    setCurrentItems(sortedData);
    setPageCount(Math.ceil(data.length / limit));
    settotalResults(data.length);
  }, [itemOffset, limit, data]);

  const handleSearch = async (searchQuery) => {
    setQuery(searchQuery.searchQuery);
    const response = await api.post(
      "/api/egazette-documents/search/meta/gazette/special",
      {
        categoryId: 3,
        type: searchQuery.keyword,
        query: searchQuery.searchQuery,
        stateId,
      }
    );

    setData(response.data);
  };
  const openModal = async (uuid, egTitleId, startPageNumber, endPageNumber) => {
    setTitleId(egTitleId);

    try {
      fetchPdf(uuid, startPageNumber, endPageNumber);
      setFileUUID(uuid);
      setIsModalOpen(true);
    } catch (error) {
      console.error("Error in fetching startPage or PDF:", error);
    }
  };

  const fetchPdf = async (uuid, startPageNumber, endPageNumber) => {
    try {
      const response = await api.post(
        "/document/pdf/pbt",
        { fileUUID: uuid, startPageNumber, endPageNumber },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      const pdfData = response.data.pdfData;

      const byteCharacters = atob(pdfData);
      const byteNumbers = new Array(byteCharacters.length);
      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);

      const blob = new Blob([byteArray], { type: "application/pdf" });
      const url = URL.createObjectURL(blob);

      setFile(url);
    } catch (error) {
      console.error("Error fetching PDF:", error);
    }
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setFile(null);
    setTitleId(0);
  };

  const downloadPdf = async () => {
    if (!file) return;

    const response = await api.post("/document/pdf/getFileName/pbt", {
      egTitleId: titleId,
    });

    const fileName = response.data;
    // Fetch the Blob from the file URL
    fetch(file)
      .then((res) => res.blob())
      .then((blob) => {
        // Use downloadjs to download the PDF
        download(blob, "Act " + fileName, "application/pdf");
      })
      .catch((err) => console.error("Error downloading PDF:", err));
  };

  const handlePageClick = (event) => {
    const newOffset = (event.selected * limit) % data.length;
    setItemOffset(newOffset);

    const syariahBody = document.querySelector(".egazette-search-body");
    if (syariahBody) {
      const bodyTop = syariahBody.getBoundingClientRect().top + window.scrollY;
      window.scrollTo({ top: bodyTop - 75, behavior: "smooth" });
    }
    setCurrentPage(event.selected);
  };
  return (
    <div>
      {!loading ? (
        <>
          {" "}
          <div className="medal-state-body">
            <SpecialSearch
              limit={limit}
              setLimit={setLimit}
              ready={true}
              query={query}
              onSearch={handleSearch}
            />
            <h1 className="medal-state-title">
              {stateName.toUpperCase()} MEDAL HONOURS (DATUKSHIP AND
              SUSTAINABILITY)
            </h1>
            <div>
              <table className="medal-state-table">
                <thead>
                  <tr>
                    <th style={{ width: "15%" }}>
                      <div className="medal-state-table-header">
                        Gazette No.
                      </div>
                    </th>
                    <th style={{ width: "70%" }}>
                      <div className="medal-state-table-header">Title</div>
                    </th>
                    <th style={{ width: "15%" }}>
                      <div className="medal-state-table-header">
                        Publication Date
                      </div>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {currentItems.map((item) => (
                    <tr key={item.id}>
                      <td style={{ textAlign: "center" }}>
                        {item.egDocumentDto.titles[0].no}
                      </td>
                      <td
                        className="medal-state-table-title"
                        dangerouslySetInnerHTML={{
                          __html:
                            item.egDocumentDto.titles[0].titleBM ||
                            item.egDocumentDto.titles[0].titleBI,
                        }}
                        onClick={() => {
                          openModal(
                            item?.documentBlobDto.fileUUID,
                            item.egDocumentDto.titles[0].egTitleId,
                            item.egDocumentDto.titles[0].startPageNumber,
                            item.egDocumentDto.titles[0].endPageNumber
                          );
                        }}
                      ></td>
                      <td style={{ textAlign: "center" }}>
                        {new Date(
                          item?.egDocumentDto.publicationDate
                        ).toLocaleDateString("en-GB", {
                          day: "2-digit",
                          month: "2-digit",
                          year: "numeric",
                        })}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            <Pagination
              handlePageClick={handlePageClick}
              pageCount={pageCount}
              currentPageNumber={currentPage}
              totalResult={totalResults}
              limit={limit}
              offset={itemOffset}
            />
          </div>
          <Modal
            isOpen={isModalOpen}
            onClose={closeModal}
            keyword={""}
            pdf={file}
            pageNumber={1}
            fileUUID={fileUUID}
            downloadPdf={(uuid) => downloadPdf(uuid)}
          />
        </>
      ) : (
        <div style={{ display: "flex", justifyContent: "center" }}>
          <CircularProgress />
        </div>
      )}
    </div>
  );
};

export default MedalFederalPage;
